"use client";
import React, { useCallback, useMemo, useState } from "react";
import { Input } from "@/ui/index";
import { ConfirmDialog } from "@/ui/modals/ConfirmDialog/ConfirmDialog";
import { Label } from "@cmp-src/primitives/label";

type RecurringOptions = "this" | "future" | "all";

export interface Props {
  open: boolean;
  onClose: () => void;
  confirmFunction: (recurring: RecurringOptions) => void;
}

export function ReservationRecurringEditConfirm({
  onClose,
  open,
  confirmFunction
}: Props) {
  const [recurringValue, setRecurringValue] =
    useState<RecurringOptions>("this");
  const onCloseBind = useCallback(() => {
    setRecurringValue("this");
    onClose();
  }, [setRecurringValue, onClose]);

  const options: {
    value: RecurringOptions;
    label: string;
    disabled: boolean;
  }[] = useMemo(
    () => [
      { label: "Only this reservation", value: "this", disabled: false },
      {
        label: "This and all the future reservations",
        value: "future",
        disabled: false
      },
      { label: "All the reservations", value: "all", disabled: false }
    ],
    []
  );

  return (
    <ConfirmDialog
      title={"Edit Recurring Reservation"}
      open={open}
      onConfirm={() => {
        confirmFunction(recurringValue);
      }}
      onClose={onCloseBind}
      type="confirm"
    >
      <div className="mt-2 flex flex-col space-y-4 text-sm">
        {options.map((option) => (
          <Label
            key={option.value}
            className="block"
          >
            <Input
              type="radio"
              onChange={() => {
                setRecurringValue(option.value);
              }}
              checked={option.value === recurringValue}
              disabled={option.disabled}
            />
            <span className="ml-2">{option.label}</span>
          </Label>
        ))}
      </div>
    </ConfirmDialog>
  );
}
